import { Platform, StyleSheet, Text, View } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { useCustomTheme } from "@luna-restaurant/ui";
import { MenuCardHeader } from "./MenuCard/MenuCardHeader";
import { SchoolHolidayIndicator } from "./SchoolHolidayIndicator";
export const NoMenuCard = ({ dayNumber, type, title, showSchoolHolidayIndicator, hasBeenPublished, isOutOfMonth, }) => {
    const { colors, fonts } = useCustomTheme();
    const { t } = useTranslation();
    const noMenuCardTypesMap = {
        publicHoliday: {
            emoji: "🎉",
            title: t("common.publicHoliday"),
            backgroundColor: colors.successLighter,
        },
        schoolClosed: {
            emoji: "🏫",
            title: t("common.schoolClosed"),
            backgroundColor: colors.sectionBackground,
        },
        schoolHoliday: {
            emoji: "🏝️",
            title: t("common.schoolHolidays"),
            backgroundColor: colors.palette.banana90,
        },
        planning: {
            emoji: "✍️",
            title: t("mealPlan.inPlanning"),
            backgroundColor: colors.sectionBackground,
        },
    };
    const displayData = noMenuCardTypesMap[type];
    const displayTitle = title ?? displayData.title;
    return (<View style={[
            styles.container,
            {
                backgroundColor: colors.background,
                borderColor: hasBeenPublished && !isOutOfMonth
                    ? colors.border
                    : colors.mutedBorder,
            },
        ]}>
      <MenuCardHeader dayNumber={dayNumber} noMenu/>

      {showSchoolHolidayIndicator && (<SchoolHolidayIndicator style={styles.schoolHolidayIndicator}/>)}

      <View style={[styles.card, { backgroundColor: displayData.backgroundColor }]}>
        <View style={styles.content}>
          <Text style={styles.emoji}>{displayData.emoji}</Text>
          <Text style={[styles.title, { ...fonts.display }]} numberOfLines={5} ellipsizeMode="tail">
            {displayTitle}
          </Text>
        </View>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        borderRadius: 6,
        padding: 8,
        marginBottom: 0,
        borderWidth: 1,
    },
    card: {
        flex: 1,
        alignItems: "stretch",
        justifyContent: "center",
        borderRadius: 6,
        gap: 24,
        padding: 16,
        marginTop: 8,
    },
    content: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        gap: 40,
    },
    schoolHolidayIndicator: {
        marginVertical: 8,
    },
    title: {
        fontSize: 44,
        lineHeight: 48.4,
        textAlign: "center",
        maxWidth: "100%",
        paddingHorizontal: 8,
        ...(Platform.OS === "web"
            ? {
                hyphens: "auto",
            }
            : {}),
    },
    emoji: {
        fontSize: 46,
        lineHeight: 48.4,
    },
});
//# sourceMappingURL=NoMenuCard.js.map